/* RESPONSIBLE TEAM: team-automation-foundations */
import type AppService from 'embercom/services/app-service';
import BaseValidator from 'ember-cp-validations/validators/base';
import { inject as service } from '@ember/service';
import type WorkflowConnector from 'embercom/models/operator/visual-builder/step/attribute-collector';
import type InsertableActionField from 'embercom/models/workflow-connector/insertable-action-field';

export default class WorkflowStepInputParameterMapping extends BaseValidator {
  @service declare intl: $TSFixMe;
  @service declare appService: AppService;

  validate(_stepType: any, _options: ValidationOptions, model: WorkflowConnector | any) {
    let insertableAction = model.action;

    if (!insertableAction) {
      return true; // Skip this validator until action is specified
    }

    if (!insertableAction.hasRequestParameters) {
      return true; // Skip this validator until action has request parameters
    }

    // A descriptor with a non-null source self-provides its runtime value
    // ('fin' = collected from conversation context, 'attribute' = baked-in
    // workspace attribute, 'custom' = baked-in literal/expression) and does
    // not need a workflow-step mapping. Only descriptors with source == null
    // require a mapping in actionInputParameterMappings.
    let fieldsRequiringMapping = insertableAction.requestParameters.filter(
      (field: InsertableActionField) => !field.source,
    );

    if (fieldsRequiringMapping.length > model.actionInputParameterMappings.length) {
      return this.intl.t(
        'operator.workflows.visual-builder.validations.workflow-connector.missing-input-mapping',
      );
    } else {
      return true;
    }
  }

  static getDependentsFor() {
    return [
      'model.action',
      'model.actionInputParameterMappings',
      'model.actionInputParameterMappings.length',
    ];
  }
}
